import script from "./SelectYearNew.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectYearNew.vue?vue&type=script&setup=true&lang=js"

import "./SelectYearNew.vue?vue&type=style&index=0&id=23528490&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23528490"]])

export default __exports__